<template>
  <div
    class="foldMemoList"
    :class="{
      sort: sort,
    }"
  >
    <div
      class="header"
      :style="{
        padding: $isElectron ? '40px 0' : '10px 0',
      }"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeClicked"
        style="cursor: pointer"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.954 0.849705C14.0332 0.928666 14.096 1.02247 14.1388 1.12574C14.1817 1.22901 14.2037 1.33972 14.2037 1.45153C14.2037 1.56334 14.1817 1.67405 14.1388 1.77732C14.096 1.88059 14.0332 1.97439 13.954 2.05335L2.05352 13.9538C1.8939 14.1134 1.67742 14.2031 1.45169 14.2031C1.22597 14.2031 1.00948 14.1134 0.849869 13.9538C0.690256 13.7942 0.600586 13.5777 0.600586 13.352C0.600586 13.1263 0.690256 12.9098 0.849869 12.7502L12.7503 0.849705C12.8293 0.770544 12.9231 0.707739 13.0264 0.664886C13.1296 0.622033 13.2404 0.599976 13.3522 0.599976C13.464 0.599976 13.5747 0.622033 13.678 0.664886C13.7812 0.707739 13.875 0.770544 13.954 0.849705Z"
          fill="#9D9D9D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.849827 0.849705C0.770666 0.928666 0.707861 1.02247 0.665008 1.12574C0.622155 1.22901 0.600098 1.33972 0.600098 1.45153C0.600098 1.56334 0.622155 1.67405 0.665008 1.77732C0.707861 1.88059 0.770666 1.97439 0.849827 2.05335L12.7503 13.9538C12.9099 14.1134 13.1264 14.2031 13.3521 14.2031C13.5778 14.2031 13.7943 14.1134 13.9539 13.9538C14.1136 13.7942 14.2032 13.5777 14.2032 13.352C14.2032 13.1263 14.1136 12.9098 13.9539 12.7502L2.05347 0.849705C1.97451 0.770544 1.88071 0.707739 1.77744 0.664886C1.67417 0.622033 1.56346 0.599976 1.45165 0.599976C1.33984 0.599976 1.22913 0.622033 1.12586 0.664886C1.02259 0.707739 0.928788 0.770544 0.849827 0.849705Z"
          fill="#9D9D9D"
        />
      </svg>

      <h2>{{ $t('foldMemoList.detail.title') }}</h2>
      <span v-if="!sort" @click="sortClicked">
        <svg-icon iconClass="sort"></svg-icon>
      </span>
      <div class="btn" @click="save" v-else>{{ $t('foldMemoList.detail.btn') }}</div>
    </div>
    <div class="tip" v-show="sort">{{ $t('foldMemoList.detail.tip') }}</div>
    <div v-show="loading" class="loading">{{ $t('foldMemoList.detail.loading') }}</div>

    <draggable v-bind="dragOptions" v-model="pinnedMemos" :move="checkMove">
      <transition-group>
        <div class="memo" :data-slug="memo.slug" v-for="(memo, index) in pinnedMemos" v-bind:key="memo.slug">
          <memo
            :memo="memo"
            :highlight_word="query"
            v-on:memo-pinned="pinMemo"
            v-on:memo-unpinned="unpinMemo"
            v-on:memo-removed="removeMemo"
            v-on:memo-updated="updatedMemo"
            v-on:tag-clicked="tagClicked"
            v-on:open-thread="openThread"
            v-on:share-clicked="shareClicked"
            v-on:add-linked-memo="addLinkedMemo"
            v-on:set-query="setQuery"
            :is_Thread="true"
            :is_Sort="sort"
          ></memo>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>
<script>
import Memo from '../components/Memo.vue'
import DBUtil from '../utils/DBUtil'
import emitter from '../utils/eventbus.js'
import draggable from 'vuedraggable'

export default {
  components: {
    Memo,
    draggable,
  },
  data() {
    return {
      me: this.$store.state.me,
      loading: false,
      http_direct: false,
      pinnedMemos: [],
      dragOptions: {
        animation: 300,
        group: 'description',
        disabled: true,
        ghostClass: 'ghost',
      },
      sort: false,
      changedMemos: [],
    }
  },

  methods: {
    async loadMemos(slug) {
      let queryPinnedMemos = await DBUtil.getPinnedMemos()
      this.pinnedMemos = queryPinnedMemos
      this.loading = false
      if (slug) {
        this.scrollToMemo(slug)
      }
      if (this.pinnedMemos.length === 0) {
        this.$emit('close-clicked')
      }
    },
    removeMemo(memo) {
      this.pinnedMemos = this.pinnedMemos.filter((m) => m.slug !== memo.slug)
      if (this.pinnedMemos.length === 0) {
        this.$emit('close-clicked')
      }
      console.log(this.pinnedMemos)
      this.$emit('memo-removed', memo)
    },
    closeClicked() {
      this.$emit('close-clicked')
    },
    tagClicked(tag) {
      this.$store.commit('setStartDate', null)
      this.$store.commit('setEndDate', null)
      this.$store.commit('setSelectedSource', null)
      this.$store.commit('setSelectedTag', null)
      this.$store.commit('setType', null)
      this.$store.commit('setSelectedTag', tag.trim())
      this.$emit('tag-clicked', tag)
      this.closeClicked()
    },
    removeReply(reply) {
      this.memo.backlinked_memos.splice(this.memo.backlinked_memos.indexOf(reply), 1)
      // this.memo.backlinked_count -= 1;
    },
    updatedReply(reply) {
      console.log(this.memo)
      let index
      for (let i = 0; i < this.memo.backlinked_memos.length; i++) {
        const _reply = this.memo.backlinked_memos[i]
        if (_reply.id === reply.id) {
          index = i
          if (_reply.backlinked_memos) reply.backlinked_memos = _reply.backlinked_memos
          break
        }
      }
      this.$set(this.memo.backlinked_memos, index, reply)
    },
    updatedMemo(memo) {
      let pIndex = 0
      this.pinnedMemos.map((pinnedMemo, i) => {
        if (pinnedMemo.slug == memo.slug) {
          pinnedMemo = memo
          pIndex = i
        }
      })

      this.$set(this.pinnedMemos, pIndex, memo)
    },
    openThread(_memo) {
      this.$emit('thread-clicked', _memo)
    },
    shareClicked(memo) {
      this.$emit('share-clicked', memo)
    },
    clickMembership() {
      this.closeClicked()
      this.$emit('membership-clicked')
    },
    addLinkedMemo(_memo) {
      this.closeClicked()
      this.$emit('add-linked-memo', _memo)
    },
    pinMemo(memo) {
      setTimeout(() => {
        this.loadMemos()
      }, 500)
    },
    unpinMemo(memo) {
      memo.pin = 0
      setTimeout(() => {
        this.loadMemos()
      }, 500)
    },
    // 开启排序
    sortClicked() {
      this.sort = !this.sort
      this.dragOptions.disabled = !this.dragOptions.disabled
    },
    save() {
      this.sortClicked()
      // check pin 是否大于 90
      let pinnedMemos = this.pinnedMemos
      let pinnedMemosPin = pinnedMemos.map((memo) => memo.pin)
      let maxPin = Math.max(...pinnedMemosPin)
      if (maxPin > 90) {
        // 大于90 按照pin从小到大顺序重置 pin
        pinnedMemosPin.sort((a, b) => a - b)
        pinnedMemosPin.forEach((pin, index) => {
          pinnedMemos[index].pin = index + 1
        })
        pinnedMemos.forEach((memo) => {
          let file_ids = memo.file_ids
          if (memo.files.length) {
            file_ids = memo.files.map((file) => {
              return file.id
            })
          }
          DBUtil.editMemo({
            ...memo,
            file_ids,
          })
        })
      }

      this.changedMemos.forEach(async (memo) => {
        let file_ids = memo.file_ids
        if (memo.files.length) {
          file_ids = memo.files.map((file) => {
            return file.id
          })
        }
        let res = await DBUtil.editMemo({
          ...memo,
          file_ids,
        })
        console.log(res)
      })
    },
    // 排序后的回调
    checkMove(evt) {
      const { draggedContext, relatedContext } = evt
      const memo = JSON.parse(JSON.stringify(draggedContext.element))
      const futureMemo = JSON.parse(JSON.stringify(relatedContext.element))
      memo.pin = relatedContext.element.pin
      futureMemo.pin = draggedContext.element.pin

      const { index, futureIndex } = draggedContext
      this.pinnedMemos[index].pin = relatedContext.element.pin
      this.pinnedMemos[futureIndex].pin = draggedContext.element.pin

      // 判断 changedMemos 中是否存在 memo
      let indexInChangedMemos = this.changedMemos.findIndex((item) => item.slug === memo.slug)
      if (indexInChangedMemos === -1) {
        this.changedMemos.push(memo)
      } else {
        this.changedMemos[indexInChangedMemos] = memo
      }

      // 判断 changedMemos 中是否存在 futureMemo
      indexInChangedMemos = this.changedMemos.findIndex((item) => item.slug === futureMemo.slug)
      if (indexInChangedMemos === -1) {
        this.changedMemos.push(futureMemo)
      } else {
        this.changedMemos[indexInChangedMemos] = futureMemo
      }
    },
    scrollToMemo(slug) {
      if (!slug) {
        return
      }
      this.$nextTick(() => {
        let memo = document.querySelector(`div[data-slug="${slug}"]`)
        if (memo) {
          memo.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      })
    },
  },
  mounted() {
    emitter.on('memo-updated', (memo) => {
      console.log('memo-updated', memo.slug)
      this.updatedMemo(memo)
    })
  },
}
</script>
<style scoped>
div.foldMemoList {
  padding: 10px 0;
  max-width: 648px;
  max-height: 100%;
  /* overflow: auto; */
  margin: 0px 10px 20px 0;
  position: relative;
  background: (--defaultBg);
  margin: 0 auto;
}

div.foldMemoList .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  height: 52px;
  box-sizing: border-box;
}

div.foldMemoList .header svg {
  cursor: pointer;
  padding: 7px 0px;
}

div.foldMemoList .header h2 {
  font-weight: bold;
  font-size: 18px;
  /* color: #323232; */
}

div.foldMemoList .header .close {
  padding: 6px;
  color: grey;
  cursor: pointer;
}

div.foldMemoList .header .btn {
  padding: 6px 10px;
  background: #30cf79;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

div.foldMemoList .tip {
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  color: var(--descText);
}

div.foldMemoList .loading {
  padding: 10px;
  text-align: center;
  color: var(--descText);
}

div.foldMemoList .memo {
  margin: 10px 0;
}

div.foldMemoList .memo:first-child {
  margin-top: 0;
}

.sort .memo {
  cursor: move;
}

div.card {
  position: relative;
  background: #ffffff;
  border-radius: 6px;
  padding: 15px;
}

.memo {
  /* padding: 10px 10px; */
}

div.related {
  color: #8f9193;
  font-size: 12px;
  padding: 0;
  cursor: pointer;
  margin-top: 6px;
}

div.related ul {
  list-style-type: none;
  padding-inline-start: 0;
  line-height: 2;
  margin: 6px 0 0;
}

div.related ul li {
  display: flex;
  align-items: center;
}

div.related ul li div.icon {
  margin-right: 6px;
  width: 12px;
  height: 12px;
  display: flex;
}

div.related ul li div.text {
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.replies {
  margin-top: 18px;
  margin-bottom: 10px;
}

.replies p {
  color: #9d9d9d;
  text-align: center;
  font-size: 12px;
}

.replies h3 {
  font-weight: bold;
  font-size: 14px;
  color: #323232;
  margin-top: 20px;
  margin-left: 10px;
}

.replies .pro {
  font-weight: normal;
  font-size: 12px;
  color: #9d9d9d;
  border: 1px solid;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 4px;
}

.replies .reply {
  margin: 10px 0;
}

div.reply div.reply-card {
  position: relative;
  background: #ffffff;
  border-radius: 6px;
  padding: 15px;
}

div.reply div.reply-card:hover {
  box-shadow: 0px 2px 10px #dddddd;
}

div.reply div.reply-card div.tools {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
}

div.reply div.reply-card:hover div.tools {
  display: block;
}

div.reply.limited {
  font-size: 14px;
  color: #8f9193;
}

div.reply.limited a {
  color: #5783f7;
  text-decoration: none;
}

.time {
  color: #8f9193;
  font-size: 12px;
  margin-bottom: 4px;
}

.content {
  color: #323232;
  font-size: 14px;
}

.content /deep/ a,
.content /deep/ a:visited {
  color: #5783f7;
  text-decoration: none;
}

.content /deep/ span.tag {
  color: var(--tagColor);
  cursor: pointer;
}

.content /deep/ ul,
.content /deep/ ol {
  padding-inline-start: 22px;
  margin: 0;
}

.content /deep/ li {
  line-height: 1;
}

.content /deep/ p {
  line-height: 1.8;
  margin: 0;
  min-height: 20px;
}

.files img {
  width: 100px;
  height: 100px;
  border: 1px solid #e6e6e6;
  cursor: pointer;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 6px;
}

blockquote.parent {
  font-size: 12px;
  color: #8f9193;
  border-left: 2px solid #e6e6e6;
  margin: 10px 0 0 0;
  padding-left: 10px;
  cursor: pointer;
}

.input-box {
  margin-top: 10px;
}

/* .list-enter-active,
.list-leave-active {
  transition: all 1s;
  max-height: 100000px;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  max-height: 0;
} */
</style>
